<section>
    @if(hasFavorites()) {
        <div>
            <p class="fav">Favorites</p>
        </div>
        <div class="w-100 row custom-gutter g-2 g-md-3 mt-0">
            @for (item of dashboardItems; track item) {
                @if(!item.disabled && item.favorite) {
                    <div class="col-6 col-xxl-3 col-xl-3 col-md-6 col-lg-4 col-sm-6">
                        <app-tile 
                            [tileInfo]="item" 
                            [backgroundColor]="'linear-gradient(152.5deg, rgba(209, 249, 255, 0.12) 26.96%, rgba(96, 117, 255, 0.12) 99.28%)'"
                            (favoriteUpdated)="updateDashboardItems()">
                        </app-tile>
                    </div>
                }
            }
        </div>
        <mat-divider class="mt-3"></mat-divider>
    }
    <div class="w-100 row custom-gutter g-2 g-md-3 mt-0">
        @for (item of dashboardItems; track item) {
            @if(!item.disabled && !item.favorite) {
                <div class="col-6 col-xxl-3 col-xl-3 col-md-6 col-lg-4 col-sm-6">
                    <app-tile [tileInfo]="item"  (favoriteUpdated)="updateDashboardItems()"></app-tile>
                </div>
            }
        }
    </div>
</section>

<div class="d-flex justify-content-center align-items-center">
    @if(areAllItemsDisabled()) {
        <div class="text-center">
             <p class="fs-20 font-weight-600 ">You do not have access to the Toolbox.</p>
              <p>Please contact your administrator or support team. </p>
        </div>
    }
</div>

